import React, { memo, useCallback, useMemo, useState } from 'react';
import { Button, Popover, Text, useTheme } from '@Sage/hoi-poi-ui';

import { DEV_ENVIRONMENTS, getDevEnvironment, setDevEnvironment } from './environments';

import './styles.scss';

const DevPopUp = memo(() => {
    const [selected, setSelected] = useState(getDevEnvironment());
    const theme = useTheme();

    const handleSetEnvironment = useCallback(
        (name) => {
            if (name === selected) {
                setSelected('');
                setDevEnvironment('');
            } else {
                setSelected(name);
                setDevEnvironment(name);
            }

            window.location.reload();
        },
        [selected],
    );

    const PopUpContent = useMemo(() => {
        return (
            <div className="fm-dev__popup__buttons">
                {DEV_ENVIRONMENTS.map((env) => (
                    <Button
                        key={env.name}
                        size="small"
                        type={env.name === selected ? 'primary' : 'secondary'}
                        onClick={() => handleSetEnvironment(env.name)}
                    >
                        {env.name}
                    </Button>
                ))}
            </div>
        );
    }, [handleSetEnvironment, selected]);

    if (process.env.NODE_ENV !== 'development') return null;

    return (
        <div className="fm-dev__popup">
            <Popover placement="top" content={PopUpContent}>
                <div className="fm-dev__popup__tag">
                    <Text color={theme.colors.primary.white}>ENVIRONMENTS</Text>
                </div>
            </Popover>
        </div>
    );
});

export default DevPopUp;
